import React from 'react';
import Finance from '@/pages/Finance';
import ProcurementApprovalPage from '@/pages/ProcurementApprovalPage';
import FinanceApprovalsPending from '@/pages/finance/FinanceApprovalsPending';
import FinanceApprovalsApproved from '@/pages/finance/FinanceApprovalsApproved';
import FinanceApprovalsRejected from '@/pages/finance/FinanceApprovalsRejected';
import FinancePaymentsConfirmation from '@/pages/finance/FinancePaymentsConfirmation';
import PaymentRequestsConfirmationPage from '@/pages/finance/PaymentRequestsConfirmationPage';
import FinancePaymentsConfirmed from '@/pages/finance/FinancePaymentsConfirmed';
import PaymentDiscrepanciesPage from '@/pages/finance/PaymentDiscrepanciesPage';
import FinancePaymentsUpcoming from '@/pages/finance/FinancePaymentsUpcoming';
import FinancePaymentsCalendar from '@/pages/finance/FinancePaymentsCalendar';
import FinanceReports from '@/pages/finance/FinanceReports';
import CashOutflowReportPage from '@/pages/finance/CashOutflowReportPage';
import CashFlowStatementPage from '@/pages/finance/CashFlowStatementPage';
import CashFlowDetailsPage from '@/pages/finance/CashFlowDetails';
import CashFlowDetailsNewPage from '@/pages/finance/CashFlowDetailsNew';
import FinancialReportPage from '@/pages/finance/FinancialReport';
import ProfitAndLossReportPage from '@/pages/finance/ProfitAndLossReport';
import BalanceSheetPage from '@/pages/finance/BalanceSheet';
import PaymentSpeedKPIPage from '@/pages/finance/PaymentSpeedKPIPage';
import InvestorSnapshotGeneratorPage from '@/pages/finance/InvestorSnapshotGenerator';
import DepartmentCostReportPage from '@/pages/finance/DepartmentCostReportPage';
import BusinessUnitPnLPage from '@/pages/finance/BusinessUnitPnLPage';
import FinanceSpendAnalysis from '@/pages/finance/FinanceSpendAnalysis';
import FinanceAccounting from '@/pages/finance/FinanceAccounting';
import PaymentRequestsPage from '@/pages/finance/PaymentRequestsPage';
import NewPaymentRequestPage from '@/pages/finance/NewPaymentRequestPage';
import PaymentRequestDetailPage from '@/pages/finance/PaymentRequestDetailPage';
import PaymentRequestDetailBulkPage from '@/pages/finance/PaymentRequestDetailBulkPage';
import EditPaymentRequestPage from '@/pages/finance/EditPaymentRequestPage';
import ExpensesPage from '@/pages/finance/ExpensesPage';
import NewExpensePage from '@/pages/finance/NewExpensePage';
import ExpenseDetailPage from '@/pages/finance/ExpenseDetailPage';
import EditExpensePage from '@/pages/finance/EditExpensePage';
import GRNPage from '@/pages/finance/GRNPage';
import NewGRNPage from '@/pages/finance/NewGRNPage';
import GRNDetailPage from '@/pages/finance/GRNDetailPage';
import EditGRNPage from '@/pages/finance/EditGRNPage';
import CashInflowsPage from '@/pages/finance/CashInflowsPage';
import NewCashInflowPage from '@/pages/finance/NewCashInflowPage';
import CashInflowDetailPage from '@/pages/finance/CashInflowDetailPage';
import DepartmentsSettingsPage from '@/pages/finance/settings/DepartmentsSettingsPage';
import ApproversSettingsPage from '@/pages/finance/settings/ApproversSettingsPage';
import ExpenseCategoriesSettingsPage from '@/pages/finance/settings/ExpenseCategoriesSettingsPage';
import BankAccountsSettingsPage from '@/pages/finance/settings/BankAccountsSettingsPage';
import TaxSettingsPage from '@/pages/finance/settings/TaxSettingsPage';
import ExchangeRatesSettingsPage from '@/pages/finance/settings/ExchangeRatesSettingsPage';
import BusinessUnitAssignmentsPage from '@/pages/finance/settings/BusinessUnitAssignmentsPage';
import EmployeeBUAllocationsPage from '@/pages/finance/settings/EmployeeBUAllocationsPage';
import CostPositionsManagementPage from '@/pages/finance/settings/CostPositionsManagementPage';
import BankTransactionsPage from '@/pages/finance/BankTransactionsPage';
import BankBalancesPage from '@/pages/finance/BankBalancesPage';
import ImportHistoryPage from '@/pages/finance/ImportHistoryPage';
import SubscriptionsPage from '@/pages/finance/SubscriptionsPage';
import RecurringPaymentsPage from '@/pages/finance/RecurringPaymentsPage';
import ReconciliationPage from '@/pages/finance/ReconciliationPage';
import InternalTransfersPage from '@/pages/finance/InternalTransfersPage';

export const financeRoutes = [
  { path: "/finance", element: <Finance /> },
  { path: "/finance/approval/:id", element: <ProcurementApprovalPage /> },
  { path: "/finance/approvals/pending", element: <FinanceApprovalsPending /> },
  { path: "/finance/approvals/approved", element: <FinanceApprovalsApproved /> },
  { path: "/finance/approvals/rejected", element: <FinanceApprovalsRejected /> },
  { path: "/finance/payments/confirmation", element: <FinancePaymentsConfirmation /> },
  { path: "/finance/payments/payment-requests", element: <PaymentRequestsConfirmationPage /> },
  { path: "/finance/payments/confirmed", element: <FinancePaymentsConfirmed /> },
  { path: "/finance/payments/discrepancies", element: <PaymentDiscrepanciesPage /> },
  { path: "/finance/payments/upcoming", element: <FinancePaymentsUpcoming /> },
  { path: "/finance/payments/calendar", element: <FinancePaymentsCalendar /> },
  { path: "/finance/reports", element: <FinanceReports /> },
  { path: "/finance/reports/cash-outflow", element: <CashOutflowReportPage /> },
  { path: "/finance/reports/cash-flow", element: <CashFlowStatementPage /> },
  { path: "/finance/reports/cash-flow-details", element: <CashFlowDetailsPage /> },
  { path: "/finance/reports/cash-flow-new", element: <CashFlowDetailsNewPage /> },
  { path: "/finance/reports/financial-report", element: <FinancialReportPage /> },
  { path: "/finance/reports/pnl-report", element: <ProfitAndLossReportPage /> },
  { path: "/finance/reports/balance-sheet", element: <BalanceSheetPage /> },
  { path: "/finance/reports/payment-speed", element: <PaymentSpeedKPIPage /> },
  { path: "/finance/reports/investor-snapshot", element: <InvestorSnapshotGeneratorPage /> },
  { path: "/finance/reports/department-costs", element: <DepartmentCostReportPage /> },
  { path: "/finance/reports/business-unit-pnl", element: <BusinessUnitPnLPage /> },
  { path: "/finance/spend-analysis", element: <FinanceSpendAnalysis /> },
  { path: "/finance/accounting", element: <FinanceAccounting /> },
  { path: "/finance/accounting/payment-requests", element: <PaymentRequestsPage /> },
  { path: "/finance/accounting/payment-requests/new", element: <NewPaymentRequestPage /> },
  { path: "/finance/accounting/payment-requests/:id", element: <PaymentRequestDetailPage /> },
  { path: "/finance/accounting/payment-requests/bulk/:id", element: <PaymentRequestDetailBulkPage /> },
  { path: "/finance/accounting/payment-requests/:id/edit", element: <EditPaymentRequestPage /> },
  { path: "/finance/accounting/expenses", element: <ExpensesPage /> },
  { path: "/finance/accounting/expenses/new", element: <NewExpensePage /> },
  { path: "/finance/accounting/expenses/:id", element: <ExpenseDetailPage /> },
  { path: "/finance/accounting/expenses/:id/edit", element: <EditExpensePage /> },
  { path: "/finance/accounting/grn", element: <GRNPage /> },
  { path: "/finance/accounting/grn/new", element: <NewGRNPage /> },
  { path: "/finance/accounting/grn/:id", element: <GRNDetailPage /> },
  { path: "/finance/accounting/grn/:id/edit", element: <EditGRNPage /> },
  { path: "/finance/accounting/cash-inflows", element: <CashInflowsPage /> },
  { path: "/finance/accounting/cash-inflows/new", element: <NewCashInflowPage /> },
  { path: "/finance/accounting/cash-inflows/:id", element: <CashInflowDetailPage /> },
  { path: "/finance/settings/departments", element: <DepartmentsSettingsPage /> },
  { path: "/finance/settings/approvers", element: <ApproversSettingsPage /> },
  { path: "/finance/settings/categories", element: <ExpenseCategoriesSettingsPage /> },
  { path: "/finance/settings/bank-accounts", element: <BankAccountsSettingsPage /> },
  { path: "/finance/settings/tax", element: <TaxSettingsPage /> },
  { path: "/finance/settings/exchange-rates", element: <ExchangeRatesSettingsPage /> },
  { path: "/finance/settings/business-units", element: <BusinessUnitAssignmentsPage /> },
  { path: "/finance/settings/employee-allocations", element: <EmployeeBUAllocationsPage /> },
  { path: "/finance/settings/cost-positions", element: <CostPositionsManagementPage /> },
  { path: "/finance/banking/transactions", element: <BankTransactionsPage /> },
  { path: "/finance/banking/balances", element: <BankBalancesPage /> },
  { path: "/finance/banking/imports", element: <ImportHistoryPage /> },
  { path: "/finance/banking/reconciliation", element: <ReconciliationPage /> },
  { path: "/finance/subscriptions", element: <SubscriptionsPage /> },
  { path: "/finance/recurring-payments", element: <RecurringPaymentsPage /> },
  { path: "/finance/transfers", element: <InternalTransfersPage /> },
];
